import {useEffect, useState} from 'react';
import {useParams} from 'react-router';
import {useQuery} from '@apollo/client';
import {Empty, Spin} from 'antd';
import cn from 'classnames';
import _ from 'lodash';

import {collections, collectionsVariables} from '../../../shared/graphql/__generated__/collections';
import {positions, positionsVariables} from '../../../shared/graphql/__generated__/positions';
import {QUERY_COLLECTIONS} from '../../../shared/graphql/collection';
import {QUERY_POSITIONS} from '../../../shared/graphql/position';

import {Card} from './Card';

import cls from './Category.module.scss'

export const Category = () => {

    const {id} = useParams()

    let headline = ''
    switch (id) {
        case 'candles': headline = 'Ароматические свечи'; break;
        case 'handler': headline = 'Свечи в интерьерных кашпо'; break;
        case 'dinner': headline = 'Столовые свечи'; break;
        case 'interior': headline = 'Предметы интерьера'; break;
    }

    const [collection, setCollection] = useState<string|null>(null);

    useEffect(() => {
        if (id === 'dinner' || id === 'interior') {
            setCollection(null)
        }
    }, [id])

    const collections = useQuery<collections,collectionsVariables>(QUERY_COLLECTIONS, {
        variables: {
            filters: {
                enabled: {eq: true},
            },
        }
    })

    const positions = useQuery<positions,positionsVariables>(QUERY_POSITIONS, {
        variables: {
            filters: {
                category: {eq: id},
                collections: collection ? {documentId: {eq: collection}} : undefined,
            },
            sort: ['createdAt:DESC'],
            pagination: {
                limit: 100,
            }
        }
    })

    return (
        <div className={cls.page}>

            <h1>{headline}</h1>

            {(id === 'candles' || id === 'handler') &&
            <div className={cls.collections}>
                {_.map(collections.data?.collections, item => (
                    <div onClick={() => setCollection(item?.documentId === collection ? null : item?.documentId!)} key={item?.documentId} className={cn([cls.menu, item?.documentId === collection && cls.selected])}>{item?.name}</div>
                ))}
            </div>
            }

            {positions.loading && <Spin/>}
            {positions.data?.positions.length === 0 && <Empty/>}
            <div className={cls.table}>
                {_.map(positions.data?.positions, item => (
                    <Card key={item?.documentId} id={item?.documentId!} name={item?.name!} price={item?.price!} tag_hit={item?.hit!} tag_new={item?.new!} tag_pre_order={item?.pre_order!} cover={item?.cover.url!} aromas={item?.aromas ?? undefined} />
                ))}
            </div>

        </div>
    )
}